import React, { FC, useContext, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import { FormikHelpers, FormikValues } from "formik";
import { Form, Header, Rodape, WrapButton } from "../../Components";
import TextInput from "../../Components/Form/Inputs/TextInput";
import { withPlanoContext } from "../../Context/Plano";
import { PlanoContext } from "../../Context/Plano/Plano.Provider";
import { LoginSchema, RegisterSchema } from "./Checkout.schema";
import {
  AlreadyRegister,
  CheckoutContainer,
  Divider,
  RegisterForm,
  LoginForm,
  NotRegister,
  LoginTittle,
} from "./Checkout.styles";
import userIcon from "./../../Static/Images/user_icon.png";
import emailIcon from "./../../Static/Images/email_icon.png";
import cadeadoIcon from "./../../Static/Images/cadeado_icon.png";
import { withCompraContext } from "../../Context/Compra";
import { CompraContext } from "../../Context/Compra/Compra.Provider";
import PhoneIcon from "./../../Static/Images/phone_icon.png";
import AdressIcon from "./../../Static/Images/endereco_icon.png";
import debounce from "lodash/debounce";
import SelectInput from "../../Components/Form/Inputs/SelectInput";
import MaskInput from "../../Components/Form/Inputs/MaskInput";
import { APIError } from "../../Utils/APIError";
import { isBrowser, isMobile } from "react-device-detect";
import "./Checkout.css";
import { IuguService } from "../Shellhost/ShellHost";
import Loading from "../../Components/UI/Loading";
import { useHistory, useRouteMatch } from "react-router-dom";
import { GoogleLogin, GoogleLoginResponse } from "react-google-login";
import { TermoContext } from "../../Context/Termos/Termo.Provider";
import { withTermoContext } from "../../Context/Termos";

const payableWithOptions = [
  {
    label: "Cartão de crédito",
    value: "credit_card",
  },
  {
    label: "Boleto Bancário",
    value: "bank_slip",
  },
  {
    label: "Pix",
    value: "pix",
  },
];

const parcelamentoCartaoOptions = (
  valorCents: number,
  limit_parcelas: number = 12
) => {
  const valor = valorCents / 100;

  const formatValor = (val: number) => {
    return val.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  };

  let items = [
    {
      label: `1x - ${formatValor(valor)}`,
      value: 1,
    },
    {
      label: `2x - ${formatValor(valor / 2)}`,
      value: 2,
    },
    {
      label: `3x - ${formatValor(valor / 3)}`,
      value: 3,
    },
    {
      label: `4x - ${formatValor(valor / 4)}`,
      value: 4,
    },
    {
      label: `5x - ${formatValor(valor / 5)}`,
      value: 5,
    },
    {
      label: `6x - ${formatValor(valor / 6)}`,
      value: 6,
    },
    {
      label: `7x - ${formatValor(valor / 7)}`,
      value: 7,
    },
    {
      label: `8x - ${formatValor(valor / 8)}`,
      value: 8,
    },
    {
      label: `9x - ${formatValor(valor / 9)}`,
      value: 9,
    },
    {
      label: `10x - ${formatValor(valor / 10)}`,
      value: 10,
    },
    {
      label: `11x - ${formatValor(valor / 11)}`,
      value: 11,
    },
    {
      label: `12x - ${formatValor(valor / 12)}`,
      value: 12,
    },
  ];

  const idxLimit = items.findIndex((x) => x.value === limit_parcelas);

  if (idxLimit !== -1) {
    items = items.slice(0, idxLimit + 1);
  }

  return items;
};

export interface ICheckoutPage {}

const CheckoutPage: FC<ICheckoutPage> = (props) => {
  const planoContext = useContext(PlanoContext);
  const compraContext = useContext(CompraContext);
  const termoContext = useContext(TermoContext);

  const [isGoogleLogin, setIsGoogleLogin] = useState<boolean>(false);
  const [isFacebookLogin, setIsFacebookLogin] = useState<boolean>(false);
  const [formikFormHelpers, setFormikFormHelpers] = useState<
    FormikHelpers<FormikValues> | undefined
  >(undefined);
  const [showAceitarTermos, setShowAceitarTermos] = useState<boolean>(false);
  const [isEmailPasswordLogin, setIsEmailPasswordLogin] =
    useState<boolean>(false);

  const match = useRouteMatch<{ identifier: string }>();
  const history = useHistory();

  const [compraSucess, setCompraSuccess] = useState<{
    hasFatura: boolean;
    success: boolean;
    paiedWithCreditCard: boolean;
  }>({
    hasFatura: false,
    success: false,
    paiedWithCreditCard: false,
  });

  const isLoading = planoContext.isLoading || compraContext.isLoading;

  const getCreditCard = (values: any) => {
    let name: any = values.credit_card_name;
    name = name.split(" ");
    let expiration: any = values.credit_card_expiration;
    expiration = expiration.split("/");
    const cc = IuguService.CreditCard(
      values.credit_card_number,
      expiration[0],
      expiration[1],
      name.filter((x: any) => x !== name[name.length - 1]).join(" "),
      name[name.length - 1],
      values.credit_card_cvv
    );

    const credit_card = cc.toData();

    return credit_card;
  };

  const submitLoginHandler = (
    values: any,
    formikHelpers: FormikHelpers<FormikValues>
  ) => {
    setIsEmailPasswordLogin(true);
    if (showAceitarTermos) {
      setShowAceitarTermos(false);
      const sendCompra = (token_pagamento?: string) => {
        compraContext.effects &&
          compraContext.effects.saveCompra(
            {
              ...values,
              payable_with: values.payable_with,
              plan_identifier: match.params.identifier,
              password: values.password,
              parcelas: (values.parcelas && +values.parcelas) || 1,
              token_pagamento: token_pagamento,
              username: values.email,
              onSuccess: (hasFatura) => compraSuccess(hasFatura, values),
            },
            true,
            formikHelpers
          );
      };

      if (values.payable_with !== "credit_card") {
        sendCompra();
      } else {
        const credit_card = getCreditCard(values);

        IuguService.createPaymentToken(credit_card, (response) => {
          console.log(response);
          if (response.errors) {
            alert("Erro salvando cartão");
          } else {
            sendCompra(response.id);
          }
        });
      }
    } else {
      setShowAceitarTermos(true);
    }
  };

  const compraSuccess = (hasFatura: boolean, values: any) => {
    history.push({
      pathname: `${history.location.pathname}/concluir`,
    });
    setCompraSuccess({
      hasFatura,
      success: true,
      paiedWithCreditCard: values.payable_with === "credit_card",
    });
  };

  const submitCompraHandler = (
    values: any,
    formikHelpers: FormikHelpers<FormikValues>
  ) => {
    setIsEmailPasswordLogin(false);
    if (showAceitarTermos) {
      setShowAceitarTermos(false);
      const formNascimento = (values.nascimento || "").split("/");
      const nascimento = new Date();
      nascimento.setDate(+formNascimento[0]);
      nascimento.setMonth(+formNascimento[1]);
      nascimento.setFullYear(+formNascimento[2]);

      const sendCompra = (token_pagamento?: string) => {
        compraContext.effects &&
          compraContext.effects.saveCompra(
            {
              ...values,
              payable_with: values.payable_with,
              plan_identifier: match.params.identifier,
              onSuccess: (hasFatura) => compraSuccess(hasFatura, values),
              parcelas: (values.parcelas && +values.parcelas) || 1,
              nascimento,
              token_pagamento: token_pagamento,
              cpf: values.cpf.replace(/\D+/g, ""),
              isByGoogle: isGoogleLogin,
              isByFacebook: isFacebookLogin,
              telefone_celular: values.telefone_celular.replace(/\D+/g, ""),
              endereco: {
                ...values.endereco,
                numero:
                  (values.endereco && (+values.endereco.numero).toString()) ||
                  "0",
                cep: values.endereco.cep.replace(/\D+/g, ""),
              },
            },
            false,
            formikHelpers
          );
      };

      if (values.payable_with !== "credit_card") {
        sendCompra();
      } else {
        const credit_card = getCreditCard(values);

        IuguService.createPaymentToken(credit_card, (response) => {
          console.log(response);
          if (response.errors) {
            alert("Erro salvando cartão");
          } else {
            sendCompra(response.id);
          }
        });
      }
    } else {
      setShowAceitarTermos(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const identifier = match.params.identifier;

    (window as any).fbAsyncInit = function () {
      console.log("fb start");
      (window as any).FB.init({
        appId: "246158206584746",
        cookie: true, // Enable cookies to allow the server to access the session.
        xfbml: true, // Parse social plugins on this webpage
        version: "v10.0",
      });
    };

    if (!identifier) {
      history.push("/");
    } else {
      planoContext.effects &&
        planoContext.effects.getPlano(identifier, history);
    }
  }, [match.params.identifier]);

  const delayedCep = debounce(
    (cep: string, formikHelpers: FormikHelpers<FormikValues>) =>
      compraContext.effects &&
      compraContext.effects.loadCep(cep.replace(/\D+/g, ""), formikHelpers),
    700
  );

  const { error } = compraContext;

  const renderPaymentMethods = (values: any, payable_with: string) => {
    return (
      <>
        <Grid container spacing={3}>
          <Grid item xs>
            <SelectInput
              name="payable_with"
              fullWidth={isMobile}
              icon={userIcon}
              placeholder="Forma de pagamento"
              errMsg={APIError.format(error, "payable_with")}
              options={
                payable_with === "all"
                  ? payableWithOptions
                  : payableWithOptions.filter((x) => x.value === payable_with)
              }
            />
          </Grid>
          {!isMobile && values.payable_with !== "credit_card" && (
            <Grid item xs />
          )}
          {!isMobile && values.payable_with === "credit_card" && (
            <Grid item xs>
              <SelectInput
                name="parcelas"
                fullWidth={isMobile}
                icon={userIcon}
                placeholder="Parcelas"
                errMsg={APIError.format(error, "parcelas")}
                options={parcelamentoCartaoOptions(
                  (planoContext.result as any).data.value_cents,
                  (planoContext.result as any).data.interval
                )}
              />
            </Grid>
          )}
        </Grid>
        {isMobile && values.payable_with === "credit_card" && (
          <Grid container spacing={3}>
            <Grid item xs>
              <SelectInput
                name="parcelas"
                fullWidth={isMobile}
                icon={userIcon}
                placeholder="Parcelas"
                errMsg={APIError.format(error, "parcelas")}
                options={parcelamentoCartaoOptions(
                  (planoContext.result as any).data.value_cents,
                  (planoContext.result as any).data.interval
                )}
              />
            </Grid>
          </Grid>
        )}
        {values.payable_with === "credit_card" && (
          <>
            <Grid container spacing={3}>
              <div className="usable-creditcard-form">
                <div className="wrapper">
                  <div className="input-group nmb_a">
                    <div className="icon ccic-brand"></div>
                    <TextInput
                      useCustomClass={true}
                      name="credit_card_number"
                      data-iugu="number"
                      autoComplete="off"
                      className="credit_card_number"
                      placeholder="Número do Cartão"
                      type="text"
                    />
                  </div>
                  <div className="input-group nmb_b">
                    <div className="icon ccic-cvv"></div>
                    <TextInput
                      useCustomClass={true}
                      name="credit_card_cvv"
                      data-iugu="verification_value"
                      autoComplete="off"
                      className="credit_card_cvv"
                      placeholder="CVV"
                      type="text"
                    />
                  </div>
                  <div className="input-group nmb_c">
                    <div className="icon ccic-name"></div>
                    <TextInput
                      useCustomClass={true}
                      name="credit_card_name"
                      data-iugu="full_name"
                      className="credit_card_name"
                      placeholder="Titular do Cartão"
                      type="text"
                    />
                  </div>
                  <div className="input-group nmb_d">
                    <div className="icon ccic-exp"></div>
                    <MaskInput
                      format={{
                        format: "##/##",
                      }}
                      useCustomClass={true}
                      name="credit_card_expiration"
                      data-iugu="expiration"
                      className="credit_card_expiration"
                      placeholder="MM/AA"
                    />
                  </div>
                </div>
                <div className="footer">
                  <img
                    src="https://s3-sa-east-1.amazonaws.com/storage.pupui.com.br/9CA0F40E971643D1B7C8DE46BBC18396/assets/cc-icons.e8f4c6b4db3cc0869fa93ad535acbfe7.png"
                    alt="Visa, Master, Diners. Amex"
                  />
                  <a
                    className="iugu-btn"
                    rel="noreferrer"
                    href="http://iugu.com"
                    target="_BLANK"
                    tabIndex={-1}
                  >
                    <img
                      src="https://s3-sa-east-1.amazonaws.com/storage.pupui.com.br/9CA0F40E971643D1B7C8DE46BBC18396/assets/payments-by-iugu.1df7caaf6958f1b5774579fa807b5e7f.png"
                      alt="Pagamentos por Iugu"
                    />
                  </a>
                </div>
              </div>
            </Grid>
          </>
        )}
      </>
    );
  };

  const renderCompraDialogs = (
    onAccept: () => void,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined
    ) => void,
    onReject: () => void
  ) => {
    return (
      <Dialog open={showAceitarTermos}>
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Termos de Compra
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Aceito os Termos de Compra
            <br />
            <a
              onClick={() =>
                termoContext.effects &&
                termoContext.effects.getTermo("termos-de-uso-vet-saude")
              }
              style={{
                cursor: "pointer",
                color: "blue",
                fontSize: 12,
              }}
            >
              Clique aqui para ler
            </a>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              setShowAceitarTermos(false);
              setFieldValue("termosDeUso", false);
              onReject();
            }}
            color="primary"
          >
            Recusar
          </Button>
          <Button
            onClick={() => {
              onAccept();
              setFieldValue("termosDeUso", true);
            }}
            color="primary"
          >
            Aceitar
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <Loading isLoading={isLoading}>
      <Header
        showPlan={!compraSucess.success}
        history={history}
        plano={(planoContext.result as any).data}
      />
      <CheckoutContainer>
        <LoginForm>
          <LoginTittle>
            <AlreadyRegister>
              Se você já possui cadastro no app QueroVet, basta fazer seu login:
            </AlreadyRegister>
          </LoginTittle>
          <Form
            schema={LoginSchema}
            initialValues={{
              email: "",
              password: "",
              payable_with:
                ((planoContext.result as any).data &&
                  (planoContext.result as any).data.payable_with) ||
                "",
              parcelas: 1,
            }}
            onSubmit={submitLoginHandler}
          >
            {(formikHelpers) => {
              if (formikFormHelpers === undefined) {
                setFormikFormHelpers(formikHelpers);

                (window as any).onLoginFb = (res: any) => {
                  console.log("login callback", res);

                  (window as any).FB.getLoginStatus(function (response: any) {
                    console.log(response);
                    if (response.status === "connected") {
                      // Logged into your webpage and Facebook.
                      console.log("Welcome!  Fetching your information.... ");
                      (window as any).FB.api(
                        "/me?fields=id,name,email",
                        function (responseMe: any) {
                          console.log(
                            "Successful login for: " +
                              JSON.stringify(responseMe)
                          );
                          console.log("Successful login for: " + responseMe);
                          setIsFacebookLogin(true);
                          console.log("has formik helpers");
                          formikHelpers.setFieldValue(
                            "facebookData",
                            responseMe
                          );
                          formikHelpers.setFieldValue(
                            "accessToken",
                            response.authResponse.accessToken
                          );
                          formikHelpers.setFieldValue("byFacebook", true);
                          formikHelpers.setFieldValue(
                            "email",
                            responseMe.email
                          );
                          formikHelpers.setFieldValue(
                            "password",
                            response.authResponse.userID
                          );
                        }
                      );
                    }
                  });
                };
              }
              const { handleSubmit, setFieldValue, values, setSubmitting } =
                formikHelpers;
              const validLogin =
                (values.email &&
                  values.email.length > 1 &&
                  values.password &&
                  values.password.length > 1) ||
                isGoogleLogin ||
                isFacebookLogin;

              return (
                <>
                  {isEmailPasswordLogin &&
                    renderCompraDialogs(
                      () => {
                        console.log("submit");
                        handleSubmit();
                      },
                      setFieldValue,
                      () => {
                        setSubmitting(false);
                      }
                    )}
                  <Grid
                    container
                    spacing={3}
                    style={{
                      marginTop: 5,
                      alignItems: "center",
                    }}
                  >
                    {!isFacebookLogin && !isGoogleLogin && (
                      <Grid item xs>
                        <GoogleLogin
                          clientId={
                            "376547346157-e7cuo7vdrbhmja8nnrh9e4f1d0k7uh5k.apps.googleusercontent.com"
                          }
                          buttonText="Entrar com Google"
                          onSuccess={(res) => {
                            console.log("Login Success: currentUser:", res);

                            const result = res as GoogleLoginResponse;

                            setIsGoogleLogin(true);
                            setFieldValue("googleData", result.profileObj);
                            setFieldValue("accessToken", result.accessToken);
                            setFieldValue("byGoogle", true);
                            setFieldValue("email", result.profileObj.email);
                            setFieldValue(
                              "password",
                              result.profileObj.googleId
                            );
                          }}
                          onFailure={(err) => {
                            console.log(err);
                          }}
                          isSignedIn={true}
                        />
                      </Grid>
                    )}
                    {!isGoogleLogin && (
                      <Grid item xs>
                        <div
                          className="fb-login-button"
                          data-width=""
                          data-size="large"
                          data-onlogin="onLoginFb();"
                          data-button-type="login_with"
                          data-scope="public_profile, email"
                          data-layout="default"
                          data-auto-logout-link="true"
                          data-use-continue-as="false"
                        ></div>
                      </Grid>
                    )}
                    <Grid item xs></Grid>
                    <Grid item xs></Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs>
                      <TextInput
                        name="email"
                        icon={emailIcon}
                        disabled={isGoogleLogin || isFacebookLogin}
                        fullWidth={isMobile}
                        placeholder="Login app querovet"
                      />
                    </Grid>
                    {isBrowser && (
                      <Grid item xs>
                        <TextInput
                          icon={cadeadoIcon}
                          fullWidth={isMobile}
                          disabled={isGoogleLogin || isFacebookLogin}
                          name="password"
                          type="password"
                          placeholder="Senha app querovet"
                        />
                      </Grid>
                    )}
                  </Grid>

                  {isMobile && !isGoogleLogin && !isFacebookLogin && (
                    <Grid container spacing={3}>
                      <Grid item xs>
                        <TextInput
                          icon={cadeadoIcon}
                          name="password"
                          fullWidth={isMobile}
                          type="password"
                          placeholder="Senha app querovet"
                        />
                      </Grid>
                    </Grid>
                  )}

                  {validLogin && (
                    <>
                      {renderPaymentMethods(
                        values,
                        ((planoContext.result as any).data &&
                          (planoContext.result as any).data.payable_with) ||
                          "all"
                      )}
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <WrapButton
                            disabled={isLoading}
                            title="COMPRAR AGORA"
                            onClick={() => handleSubmit()}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                </>
              );
            }}
          </Form>
        </LoginForm>
        <Divider />
        <RegisterForm>
          <LoginTittle>
            <NotRegister>
              Se você não é cadastro no app QueroVet, basta preencher os campos
              abaixo:
            </NotRegister>
          </LoginTittle>
          <Form
            schema={RegisterSchema}
            initialValues={{
              parcelas: 1,
            }}
            onSubmit={submitCompraHandler}
          >
            {(formikHelpers) => {
              const { handleSubmit, values, setFieldValue, setSubmitting } =
                formikHelpers;

              return (
                <>
                  {!isEmailPasswordLogin &&
                    renderCompraDialogs(handleSubmit, setFieldValue, () => {
                      setSubmitting(false);
                    })}
                  <Grid container spacing={3}>
                    <Grid item xs>
                      <TextInput
                        name="nome"
                        icon={userIcon}
                        fullWidth={isMobile}
                        placeholder="Nome Completo"
                        errMsg={APIError.format(error, "nome")}
                      />
                    </Grid>
                    {isBrowser && (
                      <Grid item xs>
                        <SelectInput
                          name="sexo"
                          icon={userIcon}
                          fullWidth={isMobile}
                          placeholder="Informe seu sexo"
                          errMsg={APIError.format(error, "sexo")}
                          options={[
                            {
                              label: "Masculino",
                              value: "Masculino",
                            },
                            {
                              label: "Feminino",
                              value: "Feminino",
                            },
                            {
                              label: "Outro",
                              value: "Outro",
                            },
                            {
                              label: "Prefiro não informar",
                              value: "NaoInformado",
                            },
                          ]}
                        />
                      </Grid>
                    )}
                  </Grid>

                  {isMobile && (
                    <Grid container spacing={3}>
                      <Grid item xs>
                        <SelectInput
                          name="sexo"
                          fullWidth={isMobile}
                          icon={userIcon}
                          placeholder="Informe seu sexo"
                          errMsg={APIError.format(error, "sexo")}
                          options={[
                            {
                              label: "Masculino",
                              value: "Masculino",
                            },
                            {
                              label: "Feminino",
                              value: "Feminino",
                            },
                            {
                              label: "Outro",
                              value: "Outro",
                            },
                            {
                              label: "Prefiro não informar",
                              value: "NaoInformado",
                            },
                          ]}
                        />
                      </Grid>
                    </Grid>
                  )}
                  <Grid container spacing={3}>
                    <Grid item xs>
                      <TextInput
                        name="email"
                        type="email"
                        fullWidth={isMobile}
                        icon={emailIcon}
                        placeholder="Seu email"
                        errMsg={APIError.format(error, "email")}
                      />
                    </Grid>
                    {isBrowser && (
                      <Grid item xs>
                        <TextInput
                          name="password"
                          icon={cadeadoIcon}
                          fullWidth={isMobile}
                          type="password"
                          placeholder="Digite uma senha"
                          errMsg={APIError.format(error, "pasword")}
                        />
                      </Grid>
                    )}
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item xs>
                      <TextInput
                        name="confirm_email"
                        type="email"
                        fullWidth={isMobile}
                        icon={emailIcon}
                        placeholder="Repita seu email"
                      />
                    </Grid>
                    {isBrowser && (
                      <Grid item xs>
                        <TextInput
                          name="confirm_password"
                          icon={cadeadoIcon}
                          fullWidth={isMobile}
                          type="password"
                          placeholder="Repita a mesma senha"
                        />
                      </Grid>
                    )}
                  </Grid>

                  {isMobile && (
                    <Grid container spacing={3}>
                      <Grid item xs>
                        <TextInput
                          name="password"
                          icon={cadeadoIcon}
                          fullWidth={isMobile}
                          type="password"
                          placeholder="Digite uma senha"
                          errMsg={APIError.format(error, "pasword")}
                        />
                      </Grid>
                    </Grid>
                  )}

                  {isMobile && (
                    <Grid container spacing={3}>
                      <Grid item xs>
                        <TextInput
                          name="confirm_password"
                          fullWidth={isMobile}
                          icon={cadeadoIcon}
                          type="password"
                          placeholder="Repita a mesma senha"
                        />
                      </Grid>
                    </Grid>
                  )}

                  <Grid container spacing={3}>
                    <Grid item xs>
                      <MaskInput
                        name="cpf"
                        type="text"
                        errMsg={APIError.format(error, "cpf")}
                        fullWidth
                        icon={cadeadoIcon}
                        placeholder="Digite seu CPF"
                        format={{
                          format: "###.###.###-##",
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item xs>
                      <MaskInput
                        name="telefone_celular"
                        errMsg={APIError.format(error, "telefone_celular")}
                        icon={PhoneIcon}
                        fullWidth={isMobile}
                        placeholder="Digite seu celular"
                        format={{
                          format: "(##) # ####-####",
                        }}
                      />
                    </Grid>
                    {isBrowser && (
                      <Grid item xs>
                        <MaskInput
                          name="nascimento"
                          icon={userIcon}
                          errMsg={APIError.format(error, "nascimento")}
                          placeholder="Data de Nascimento"
                          format={{
                            format: "##/##/####",
                          }}
                        />
                      </Grid>
                    )}
                  </Grid>

                  {isMobile && (
                    <Grid container spacing={3}>
                      <Grid item xs>
                        <MaskInput
                          name="nascimento"
                          icon={userIcon}
                          fullWidth
                          errMsg={APIError.format(error, "nascimento")}
                          placeholder="Data de Nascimento"
                          format={{
                            format: "##/##/####",
                          }}
                        />
                      </Grid>
                    </Grid>
                  )}

                  <Grid container spacing={3}>
                    <Grid item xs>
                      <MaskInput
                        icon={AdressIcon}
                        name="endereco.cep"
                        errMsg={APIError.format(error, "endereco.cep")}
                        placeholder="Cep:"
                        fullWidth={isMobile}
                        onChangeVal={(value) => {
                          delayedCep(value, formikHelpers);
                        }}
                        format={{
                          format: "##.###-###",
                        }}
                      />
                    </Grid>
                    {isBrowser && (
                      <Grid item xs>
                        <TextInput
                          name="endereco.numero"
                          fullWidth={isMobile}
                          type="number"
                          errMsg={APIError.format(error, "endereco.numero")}
                          placeholder="Número:"
                        />
                      </Grid>
                    )}
                  </Grid>

                  {isMobile && (
                    <Grid container spacing={3}>
                      <Grid item xs>
                        <TextInput
                          fullWidth={isMobile}
                          name="endereco.numero"
                          errMsg={APIError.format(error, "endereco.numero")}
                          placeholder="Número:"
                        />
                      </Grid>
                    </Grid>
                  )}

                  <Grid container spacing={3}>
                    <Grid item xs>
                      <TextInput
                        name="endereco.logradouro"
                        errMsg={APIError.format(error, "endereco.logradouro")}
                        fullWidth
                        placeholder="Endereço"
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item xs>
                      <TextInput
                        name="endereco.bairro"
                        fullWidth={isMobile}
                        errMsg={APIError.format(error, "endereco.bairro")}
                        placeholder="Bairro:"
                      />
                    </Grid>
                    {isBrowser && (
                      <Grid item xs>
                        <TextInput
                          name="endereco.complemento"
                          errMsg={APIError.format(
                            error,
                            "endereco.complemento"
                          )}
                          fullWidth={isMobile}
                          placeholder="Complemento:"
                        />
                      </Grid>
                    )}
                  </Grid>

                  {isMobile && (
                    <Grid container spacing={3}>
                      <Grid item xs>
                        <TextInput
                          name="endereco.complemento"
                          fullWidth={isMobile}
                          errMsg={APIError.format(
                            error,
                            "endereco.complemento"
                          )}
                          placeholder="Complemento:"
                        />
                      </Grid>
                    </Grid>
                  )}

                  <Grid container spacing={3}>
                    <Grid item xs>
                      <TextInput
                        name="endereco.cidade"
                        errMsg={APIError.format(error, "endereco.cidade")}
                        disabled
                        fullWidth={isMobile}
                        placeholder="Cidade:"
                      />
                    </Grid>
                    {isBrowser && (
                      <Grid item xs>
                        <TextInput
                          name="endereco.estado"
                          errMsg={APIError.format(error, "endereco.estado")}
                          disabled
                          fullWidth={isMobile}
                          placeholder="UF:"
                        />
                      </Grid>
                    )}
                  </Grid>

                  {isMobile && (
                    <Grid container spacing={3}>
                      <Grid item xs>
                        <TextInput
                          name="endereco.estado"
                          errMsg={APIError.format(error, "endereco.estado")}
                          disabled
                          fullWidth={isMobile}
                          placeholder="UF:"
                        />
                      </Grid>
                    </Grid>
                  )}

                  <Grid container spacing={3}>
                    <Grid item xs>
                      <TextInput
                        name="endereco.latitude"
                        hiddenField
                        errMsg={APIError.format(error, "endereco.latitude")}
                        disabled
                        fullWidth={isMobile}
                        placeholder="Latitude:"
                      />
                    </Grid>
                    {isBrowser && (
                      <Grid item xs>
                        <TextInput
                          hiddenField
                          name="endereco.longitude"
                          errMsg={APIError.format(error, "endereco.longitude")}
                          fullWidth={isMobile}
                          disabled
                          placeholder="Longitude:"
                        />
                      </Grid>
                    )}
                  </Grid>

                  {isMobile && (
                    <Grid container spacing={3}>
                      <Grid item xs>
                        <TextInput
                          hiddenField
                          name="endereco.longitude"
                          errMsg={APIError.format(error, "endereco.longitude")}
                          disabled
                          fullWidth={isMobile}
                          placeholder="Longitude:"
                        />
                      </Grid>
                    </Grid>
                  )}

                  {renderPaymentMethods(
                    values,
                    ((planoContext.result as any).data &&
                      (planoContext.result as any).data.payable_with) ||
                      "all"
                  )}

                  <WrapButton
                    disabled={isLoading}
                    title="COMPRAR AGORA"
                    onClick={() => handleSubmit()}
                  />
                </>
              );
            }}
          </Form>
        </RegisterForm>
        <Rodape showNeedHelp />
      </CheckoutContainer>
    </Loading>
  );
};

export default withCompraContext(
  withPlanoContext(withTermoContext(CheckoutPage))
);
